var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1669_5133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 11,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 2.5H3.4375C3.09232 2.5 2.8125 2.77982 2.8125 3.125V13.125C2.8125 13.4702 3.09232 13.75 3.4375 13.75H11.5625C11.9077 13.75 12.1875 13.4702 12.1875 13.125V3.125C12.1875 2.77982 11.9077 2.5 11.5625 2.5Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.25V3.125M9.375 1.25V3.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.9375H10M5 8.4375H8.75M5 10.9375H7.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1669_5133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15V15H0V0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLogs);
export default __webpack_public_path__ + "static/media/transaction_logs.4c52bd253a304a6bdbc14bac44e836b3.svg";
export { ForwardRef as ReactComponent };